import { createZodDto } from 'nestjs-zod/dto';
import { userIdentitySchema } from './identity';
export class CreateRecoveryIdentityDto extends createZodDto(userIdentitySchema) {
}
